// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"cQ-z","tooltipWrapper":"dQ-z","icon":"eQ-z","tooltip":"fQ-z","content":"gQ-z"};